import {
  ActionType,
  IMiniStressTypeInfoResponse,
  MiniStressTypeInfoData,
} from "models/stressCheck/miniStressInformation";

export const miniStressCheckTypeInfoAction = (
  payload: MiniStressTypeInfoData
) => {
  return {
    type: ActionType.MINI_STRESS_INFO,
    payload,
  };
};

export const handleErrorAction = (payload: string) => {
  return {
    type: ActionType.MINI_STRESS_INFO_ERROR,
    payload,
  };
};

export const handleSuccesAction = (payload: IMiniStressTypeInfoResponse) => {
  return {
    type: ActionType.MINI_STRESS_INFO_SUCCESS,
    payload,
  };
};

export const handleResetDataAction = () => {
  return {
    type: ActionType.MINI_STRESS_INFO_RESET_DATA,
  };
};
